<template>
  <div id="kpis-dashboard">
    <h5>{{$t('dashboard_new_evollu.titles.kpis')}} </h5>
    <!--<div class="row mt-2 no-gutters evollu-form">
      <div class="row">
        <div class="col-4">
          <label class="form-label">
            {{ $t('dashboard_new_evollu.kpis.filters.timePeriod.title') }}
          </label>
          <multiselect
            id="entities-filter"
            v-model="filters.kpiTimePeriod"
            :options="timePeriods"
            track-by="id"
            :custom-label="opt => $t(`dashboard_new_evollu.kpis.filters.timePeriod.${opt.slug}`, 'N/A')"
            :placeholder="$t('dashboard_new_evollu.kpis.filters.timePeriod.title')"
            :allow-empty="false"
            :multiple="false"
            :internal-search="true"
          />
        </div>

        <div class="col-12 col-md-4">
          <label class="form-label">
            {{ $t('activities_agenda.table.facility') }}
          </label>
          <multiselect
            id="entities-filter"
            v-model="filters.facility"
            :options="readableFacilities"
            track-by="id"
            :customLabel="formatedEntityLabel"
            :placeholder="$t('activities_agenda.table.facility')"
            :allow-empty="true"
            :multiple="false"
            :internal-search="true"
            :disabled="!readableFacilities.length"
          >

            <template slot="clear">
                <span class="multiselect__clear" v-if="filters.facility !== null"
                      @mousedown.prevent.stop="filters.facility = null"></span>
            </template>
          </multiselect>
        </div>
      </div>
    </div>-->

    <div v-if="isLoading" class="d-flex align-items-center flex-column py-5">
          <span class="mb-3">{{$t('agenda.statistics.loading')}}</span>
          <hollow-dots-spinner
            :animation-duration="1000"
            :size="60"
            color="#29c4a9"
          />
        </div>
    <div v-else-if="filters.facility !== null" class="row mt-4">
      <div class="row col-12 mt-3">
        <h4 class="mb-0">{{$t('menu.checkup_plus/patients')}}</h4>
        <div v-if="parsedData !== null" class="row col-12 mt-5">
          <div class="col-3">
          <span class="is-bold" style="font-size: 1.2em">
            {{$t('dashboard_new_evollu.kpis.labels.total_patients')}}:
          </span>
            <span style="font-size: 1.2em">
            {{parsedData.patients.total}}
          </span>
          </div>
          <div class="col-3 ml-5" v-if="parsedData.patients.ageGraph.data.labels.length > 0">
            <HorizontalDonutChartWidgetV2
              :title="parsedData.patients.ageGraph.title"
              :hidePercentage="false"
              :data="parsedData.patients.ageGraph.data"
            >
            </HorizontalDonutChartWidgetV2>
          </div>
          <div class="col-3" v-if="parsedData.patients.sexGraph.data.labels.length > 0">
            <HorizontalDonutChartWidgetV2
              :title="parsedData.patients.sexGraph.title"
              :hidePercentage="false"
              :data="parsedData.patients.sexGraph.data"
            >
            </HorizontalDonutChartWidgetV2>
          </div>
        </div>
        <div class="row col-12 mt-2 justify-content-center" v-else>
          <span class=" is-bold">{{ $t('dashboard_new_evollu.values.empty_graphs') }}</span>
        </div>
      </div>
      <div class="row col-8 mt-3">
        <h4 class="mb-0">{{$t('dashboard_new_evollu.kpis.titles.evaluations')}}</h4>
        <div v-if="parsedData !== null" class="row col-12 mt-5">
          <div class="col-5">
            <div class="row">
              <span class="is-bold" style="font-size: 1.2em">
                {{$t('dashboard_new_evollu.kpis.labels.total_evaluations')}}:
                <span style="font-size: 1em; font-weight: normal">
                  {{parsedData.evaluations.total}}
                </span>
              </span>
            </div>
            <div class="row mt-2">
              <span class="is-bold" style="font-size: 1.2em">
                {{$t('dashboard_new_evollu.kpis.labels.mean_evaluation_duration')}}:
                <span style="font-size: 1em; font-weight: normal">
                  {{parsedData.evaluations.meanDuration}}
                </span>
              </span>
            </div>
            <div class="row mt-4">
              <span class="is-bold" style="font-size: 1.2em">
                {{$t('dashboard_new_evollu.kpis.labels.total_tests')}}:
                <span style="font-size: 1em; font-weight: normal">
                  {{parsedData.evaluations.totalTests}}
                </span>
              </span>
            </div>
            <div class="row mt-2">
              <span class="is-bold" style="font-size: 1.2em">
                {{$t('dashboard_new_evollu.kpis.labels.mean_tests_per_evaluation')}}:
                <span style="font-size: 1em; font-weight: normal;">
                  {{parsedData.evaluations.meanTests}}
                </span>
              </span>
            </div>


          </div>
          <div class="col-7" v-if="parsedData.patients.ageGraph.data.labels.length > 0">
            <HorizontalDonutChartWidgetV2
              :title="parsedData.evaluations.evaluationsGraph.title"
              :hidePercentage="false"
              :data="parsedData.evaluations.evaluationsGraph.data"
            >
            </HorizontalDonutChartWidgetV2>
          </div>
        </div>
        <div class="row col-12 mt-2 justify-content-center" v-else>
          <span class=" is-bold">{{ $t('dashboard_new_evollu.values.empty_graphs') }}</span>
        </div>
      </div>

    </div>



    <div v-else class="text-center py-5">
      <span class="mb-3 is-bold">{{ $t('dashboard_new_evollu.values.empty_graphs') }}</span>
    </div>
  </div>
</template>

<script>
import HorizontalDonutChartWidgetV2 from "@/components/common/statistics/HorizontalDonutChartWidgetV2";
import { OneCareService } from "@/api/OneCareService";
import { HollowDotsSpinner } from 'epic-spinners'
import LocalStorageHelper from '@/local-storage/LocalStorageHelper'
import { KPIS_DASHBOARD_NEW_EVOLLU } from "@/local-storage/LocalStorageKeys";
import ResultTypePatientsModal from "@/components/checkup_plus/dashboard/ResultTypePatientsModal.vue";
import Multiselect from 'vue-multiselect';
import MultiselectLabelFormatter from '@/mixins/MultiselectLabelFormatter.vue';

export default {
  name: "GraphsDashboard",
  components: {
    Multiselect,
    HorizontalDonutChartWidgetV2,
    HollowDotsSpinner,
    ResultTypePatientsModal,
  },
  mixins: [MultiselectLabelFormatter],
  props:{
    readableFacilities: {
      type: Array,
      default: [],
      required: true
    },
    timePeriods: {
      type: Array,
      default: [],
      required: true
    },
    filters: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      graphsData: [],
      data: null,
      parsedData: null
    }
  },
  computed: {

  },
  created: function() {
  },
  methods: {
    async getKpisData() {
      this.isLoading = true;
      this.data = null
      this.parsedData = null
      try {
        this.data = await OneCareService.getKpisData(this.filters.facility.id, this.filters.period.id);
        /*this.data={
          "orgId": 774,
          "orgName": "Farmácia de Demonstração",
          "periodCode": 3,
          "periodDescription": "Last 3 Months",
          "values": [
            {
              "attributeName": "Missões concluidas",
              "attributeCode": "MISSIONS_COMPLETED",
              "measurementAttributeId": 130,
              "untis": "un",
              "value": "0",
              "info": "Total de missões criadas pela organização durante o período seleccionado",
              "cases": null,
              "universe": null,
              "gameObjects": null
            },
            {
              "attributeName": "Percentagem de Missões Concluídas",
              "attributeCode": "MISSIONS_COMPLETED_PERCENT",
              "measurementAttributeId": 131,
              "untis": "%",
              "value": "0.0",
              "info": "Percentagem de Missões completadas tendo por base o total de missões estabeleidas e o número de missões concluídas na totalidade.",
              "cases": "0",
              "universe": "0",
              "gameObjects": null
            },
            {
              "attributeName": "Número de monitorizações realizadas correctamente",
              "attributeCode": "CORRECT_MONITORINGS",
              "measurementAttributeId": 120,
              "untis": "un",
              "value": "0",
              "info": null,
              "cases": null,
              "universe": null,
              "gameObjects": null
            },
            {
              "attributeName": "Monitorizações realizadas correctamente",
              "attributeCode": "CORRECT_MONITORINGS_PERCENT",
              "measurementAttributeId": 121,
              "untis": "%",
              "value": "0",
              "info": null,
              "cases": "0",
              "universe": "0",
              "gameObjects": null
            },
            {
              "attributeName": "Jogos",
              "attributeCode": "GAMES",
              "measurementAttributeId": 124,
              "untis": "un",
              "value": "0",
              "info": "Número de jogos jogados pelos pacientes da organização.",
              "cases": null,
              "universe": null,
              "gameObjects": null
            },
            {
              "attributeName": "Jogos jogados em média por pessoa",
              "attributeCode": "GAMES_PER_PERSON_AVG",
              "measurementAttributeId": 125,
              "untis": "un",
              "value": "0",
              "info": "Número  médio de jogos tendo por base o número total de jogos jogados e o número de pessoas com jogadas no período seleccionado. ",
              "cases": "0",
              "universe": "0",
              "gameObjects": null
            },
            {
              "attributeName": "Questionários",
              "attributeCode": "QUESTIONNAIRES",
              "measurementAttributeId": 117,
              "untis": "un",
              "value": "0",
              "info": "Número de questionários respondidos na organização no periodo seleccioando",
              "cases": null,
              "universe": null,
              "gameObjects": null
            },
            {
              "attributeName": "Medições",
              "attributeCode": "MEASUREMENTS",
              "measurementAttributeId": 115,
              "untis": "un",
              "value": "41",
              "info": "Número total de medições realizadas pelos pacientes da ogranização no período seleccionado",
              "cases": null,
              "universe": null,
              "gameObjects": null
            },
            {
              "attributeName": "Média de medições por pessoa",
              "attributeCode": "MEASUREMENTS_PER_PERSON_AVG",
              "measurementAttributeId": 116,
              "untis": "un",
              "value": "4.56",
              "info": "Número médio de medições por paciente, tendo por base o total de medições relizadas e o número de pacientes com  medições no período seleccionado.",
              "cases": "41",
              "universe": "9",
              "gameObjects": null
            },
            {
              "attributeName": "Tempo médio de uma videochamada",
              "attributeCode": "VCALL_DURATION_AVG",
              "measurementAttributeId": 110,
              "untis": "s",
              "value": "0",
              "info": null,
              "cases": "0",
              "universe": "0",
              "gameObjects": null
            },
            {
              "attributeName": "Alarmes de alta prioridade",
              "attributeCode": "ALARMS_HIGH",
              "measurementAttributeId": 100,
              "untis": "un",
              "value": "0",
              "info": null,
              "cases": null,
              "universe": null,
              "gameObjects": null
            },
            {
              "attributeName": "Alarmes de alta prioridade - SOS",
              "attributeCode": "ALARMS_HIGH_SOS",
              "measurementAttributeId": 102,
              "untis": "un",
              "value": "0",
              "info": null,
              "cases": null,
              "universe": null,
              "gameObjects": null
            },
            {
              "attributeName": "Alarmes de alta prioridade - QUEDA",
              "attributeCode": "ALARMS_HIGH_FALL",
              "measurementAttributeId": 101,
              "untis": "un",
              "value": "0",
              "info": null,
              "cases": null,
              "universe": null,
              "gameObjects": null
            },
            {
              "attributeName": "Alarmes de baixa prioridade",
              "attributeCode": "ALARMS_LOW",
              "measurementAttributeId": 108,
              "untis": "un",
              "value": "3",
              "info": null,
              "cases": null,
              "universe": null,
              "gameObjects": null
            },
            {
              "attributeName": "Alarmes de média prioridade",
              "attributeCode": "ALARMS_MEDIUM",
              "measurementAttributeId": 107,
              "untis": "un",
              "value": "0",
              "info": null,
              "cases": null,
              "universe": null,
              "gameObjects": null
            },
            {
              "attributeName": "Number of appointments",
              "attributeCode": "APPOINTMENTS_NUMBER",
              "measurementAttributeId": 220,
              "untis": "un",
              "value": "26",
              "info": "Number of appointments",
              "cases": null,
              "universe": null,
              "gameObjects": null
            },
            {
              "attributeName": "Number of tests performed",
              "attributeCode": "TESTS_NUMBER",
              "measurementAttributeId": 221,
              "untis": "un",
              "value": "43",
              "info": "Number of tests (measurements) performed",
              "cases": null,
              "universe": null,
              "gameObjects": null
            },
            {
              "attributeName": "Mean tests performed per appointment",
              "attributeCode": "MEAN_TESTS_APPOINTMENT",
              "measurementAttributeId": 222,
              "untis": "un",
              "value": "1.65",
              "info": "Mean tests performed per appointment",
              "cases": null,
              "universe": null,
              "gameObjects": null
            },
            {
              "attributeName": "Standard deviation of tests performed per appointment",
              "attributeCode": "STDDEV_TESTS_APPOINTMENT",
              "measurementAttributeId": 223,
              "untis": "un",
              "value": "1.86",
              "info": "Standard deviation of tests performed per appointment",
              "cases": null,
              "universe": null,
              "gameObjects": null
            },
            {
              "attributeName": "Mean duration of appointments",
              "attributeCode": "MEAN_DURATION_APPOINTMENT",
              "measurementAttributeId": 224,
              "untis": "min",
              "value": "31.76",
              "info": "Mean duration of appointments in minutes",
              "cases": null,
              "universe": null,
              "gameObjects": null
            },
            {
              "attributeName": "Standard deviation of appointment durations",
              "attributeCode": "STDDEV_DURATION_APPOINTMENT",
              "measurementAttributeId": 225,
              "untis": "min",
              "value": "85.25",
              "info": "Standard deviation of appointment durations in minutes",
              "cases": null,
              "universe": null,
              "gameObjects": null
            },
            {
              "attributeName": "Number of Biomedical tests",
              "attributeCode": "BIOMEDICAL_TESTS_NUMBER",
              "measurementAttributeId": 226,
              "untis": "un",
              "value": "20",
              "info": "Number of Biomedical tests performed",
              "cases": null,
              "universe": null,
              "gameObjects": null
            },
            {
              "attributeName": "Number of Geriatric tests",
              "attributeCode": "GERIATRIC_TESTS_NUMBER",
              "measurementAttributeId": 227,
              "untis": "un",
              "value": "2",
              "info": "Number of Geriatric tests performed",
              "cases": null,
              "universe": null,
              "gameObjects": null
            },
            {
              "attributeName": "Number of Hearing tests",
              "attributeCode": "HEARING_TESTS_NUMBER",
              "measurementAttributeId": 228,
              "untis": "un",
              "value": "1",
              "info": "Number of Hearing tests performed",
              "cases": null,
              "universe": null,
              "gameObjects": null
            },
            {
              "attributeName": "Number of Vision/Optometry tests",
              "attributeCode": "VISION_TESTS_NUMBER",
              "measurementAttributeId": 229,
              "untis": "un",
              "value": "1",
              "info": "Number of Vision/Optometry tests performed",
              "cases": null,
              "universe": null,
              "gameObjects": null
            },
            {
              "attributeName": "Checkup-plus number of Survey/Questionnaire tests",
              "attributeCode": "QUESTIONNAIRE_TESTS_NUMBER",
              "measurementAttributeId": 230,
              "untis": "un",
              "value": "18",
              "info": "Number of Checkup-plus Surveys/Questionnaires performed",
              "cases": null,
              "universe": null,
              "gameObjects": null
            },
            {
              "attributeName": "Number of Compplex Monitoring tests",
              "attributeCode": "COMPLEX_MONITORING_TESTS_NUMBER",
              "measurementAttributeId": 231,
              "untis": "un",
              "value": "0",
              "info": "Number of Complex Monitoring tests performed",
              "cases": null,
              "universe": null,
              "gameObjects": null
            },
            {
              "attributeName": "Number of Biosign tests",
              "attributeCode": "BIOSIGN_TESTS_NUMBER",
              "measurementAttributeId": 232,
              "untis": "un",
              "value": "0",
              "info": "Number of Biosign tests performed",
              "cases": null,
              "universe": null,
              "gameObjects": null
            },
            {
              "attributeName": "Number of Biochemical Parms tests",
              "attributeCode": "BIOCHEMICAL_TESTS_NUMBER",
              "measurementAttributeId": 233,
              "untis": "un",
              "value": "1",
              "info": "Number of Biochemical Params tests performed",
              "cases": null,
              "universe": null,
              "gameObjects": null
            },
            {
              "attributeName": "Patient gender - female",
              "attributeCode": "PATIENTS_GENDER_FEMALE",
              "measurementAttributeId": 200,
              "untis": "%",
              "value": "50.72",
              "info": "Percentage of female patients",
              "cases": "35",
              "universe": "69",
              "gameObjects": null
            },
            {
              "attributeName": "Patient gender - male",
              "attributeCode": "PATIENTS_GENDER_MALE",
              "measurementAttributeId": 201,
              "untis": "%",
              "value": "31.88",
              "info": "Percentage of male patients",
              "cases": "22",
              "universe": "69",
              "gameObjects": null
            },
            {
              "attributeName": "Patient gender - undefined",
              "attributeCode": "PATIENTS_GENDER_UNDEFINED",
              "measurementAttributeId": 202,
              "untis": "%",
              "value": "17.39",
              "info": "Percentage of patients with undefined gender",
              "cases": "12",
              "universe": "69",
              "gameObjects": null
            },
            {
              "attributeName": "Patient age 18-35",
              "attributeCode": "PATIENTS_AGE_18_35",
              "measurementAttributeId": 210,
              "untis": "%",
              "value": "8.70",
              "info": "Percentage of patients aged 18-35",
              "cases": "6",
              "universe": "69",
              "gameObjects": null
            },
            {
              "attributeName": "Patient age 36-45",
              "attributeCode": "PATIENTS_AGE_36_45",
              "measurementAttributeId": 211,
              "untis": "%",
              "value": "7.25",
              "info": "Percentage of patients aged 36-45",
              "cases": "5",
              "universe": "69",
              "gameObjects": null
            },
            {
              "attributeName": "Patient age 46-55",
              "attributeCode": "PATIENTS_AGE_46_55",
              "measurementAttributeId": 212,
              "untis": "%",
              "value": "72.46",
              "info": "Percentage of patients aged 46-55",
              "cases": "50",
              "universe": "69",
              "gameObjects": null
            },
            {
              "attributeName": "Patient age 56-65",
              "attributeCode": "PATIENTS_AGE_56_65",
              "measurementAttributeId": 213,
              "untis": "%",
              "value": "1.45",
              "info": "Percentage of patients aged 56-65",
              "cases": "1",
              "universe": "69",
              "gameObjects": null
            },
            {
              "attributeName": "Patient age 66-75",
              "attributeCode": "PATIENTS_AGE_66_75",
              "measurementAttributeId": 214,
              "untis": "%",
              "value": "0.00",
              "info": "Percentage of patients aged 66-75",
              "cases": "0",
              "universe": "69",
              "gameObjects": null
            },
            {
              "attributeName": "Patient age 76-85",
              "attributeCode": "PATIENTS_AGE_76_85",
              "measurementAttributeId": 215,
              "untis": "%",
              "value": "1.45",
              "info": "Percentage of patients aged 76-85",
              "cases": "1",
              "universe": "69",
              "gameObjects": null
            },
            {
              "attributeName": "Patient age > 85",
              "attributeCode": "PATIENTS_AGE_ABOVE_85",
              "measurementAttributeId": 216,
              "untis": "%",
              "value": "2.90",
              "info": "Percentage of patients aged above 85",
              "cases": "2",
              "universe": "69",
              "gameObjects": null
            }
          ]
        }*/
        this.parseData()
      } catch (err) {
        console.log(err)
        this.showToast(this.$t('dashboard_new_evollu.errors.loading_graphs'), this.$store.state.errorToastOptions)
        this.graphsData = []
      } finally {
        this.isLoading = false;
      }
    },
    parseData() {
      let obj = {}
      obj.patients = {}
      obj.patients.total = 0
      obj.patients.sexGraph = {
        title: this.$t('dashboard_new_evollu.kpis.titles.sexGraph'),
        data: {
          warning: false,
          labels: [],
          datasets: [{
            data: [],
            backgroundColor: [],
          }]
        }
      }
      obj.patients.ageGraph = {
        title: this.$t('dashboard_new_evollu.kpis.titles.ageGraph'),
        data: {
          warning: false,
          labels: [],
          datasets: [{
            data: [],
            backgroundColor: [],
          }]
        }
      }

      obj.evaluations = {
        total: 0,
        meanDuration: 0,
        totalTests: 0,
        meanTests: 0,
        evaluationsGraph: {
          title: this.$t('ranu.records.exams_made'),
          data: {
            warning: false,
            labels: [],
            datasets: [{
              data: [],
              backgroundColor: []
            }]
          }
        }
      }

      const ageRangesColors = [
        { slug: "PATIENTS_AGE_18_35", color: "#A8D5BA" },
        { slug: "PATIENTS_AGE_36_45", color: "#FFD3B4" },
        { slug: "PATIENTS_AGE_46_55", color: "#D4B5E8" },
        { slug: "PATIENTS_AGE_56_65", color: "#B3D9FF" },
        { slug: "PATIENTS_AGE_66_75", color: "#FFB3C1" },
        { slug: "PATIENTS_AGE_76_85", color: "#FFE1A8" },
        { slug: "PATIENTS_AGE_ABOVE_85", color: "#C1E1C1" },
      ];

      const sexGraphColors = [
        { slug: "PATIENTS_GENDER_FEMALE", color: "#A8D5BA" },
        { slug: "PATIENTS_GENDER_MALE", color: "#FFD3B4" },
        { slug: "PATIENTS_GENDER_UNDEFINED", color: "#D4B5E8" },
      ];

      const testsGraphColors = [
        { slug: 'BIOMEDICAL_TESTS_NUMBER', color: '#6D98F4' },
        { slug: 'GERIATRIC_TESTS_NUMBER', color: '#8F76DB' },
        { slug: 'BIOCHEMICAL_TESTS_NUMBER', color: '#91D6D9' },
        { slug: 'HEARING_TESTS_NUMBER', color: '#FFA564' },
        { slug: 'VISION_TESTS_NUMBER', color: '#F9679E' },
        { slug: 'COMPLEX_MONITORING_TESTS_NUMBER', color: '#6D98F4' },
        { slug: 'BIOSIGN_TESTS_NUMBER', color: '#4DB889' },
        { slug: 'QUESTIONNAIRE_TESTS_NUMBER', color: '#b9a740' }
      ]

      if(this.data.values.length > 0){
        this.data.values.forEach(elem => {
          switch (elem.attributeCode) {
            case "PATIENTS_GENDER_FEMALE":
            case "PATIENTS_GENDER_MALE":
            case "PATIENTS_GENDER_UNDEFINED":
              obj.patients.sexGraph.data.labels.push(this.$t(`dashboard_new_evollu.kpis.labels.${elem.attributeCode.toLowerCase()}`));
              obj.patients.sexGraph.data.datasets[0].data.push(parseInt(elem.cases));
              const sexColorElement = sexGraphColors.find(color => color.slug === elem.attributeCode)
              obj.patients.sexGraph.data.datasets[0].backgroundColor.push( sexColorElement ? sexColorElement.color : '#'+(Math.random()*0xFFFFFF<<0).toString(16))
              obj.patients.total += parseInt(elem.cases)
              break;
            case "PATIENTS_AGE_18_35":
            case "PATIENTS_AGE_36_45":
            case "PATIENTS_AGE_46_55":
            case "PATIENTS_AGE_56_65":
            case "PATIENTS_AGE_66_75":
            case "PATIENTS_AGE_76_85":
            case "PATIENTS_AGE_ABOVE_85":
              obj.patients.ageGraph.data.labels.push(this.$t(`dashboard_new_evollu.kpis.labels.${elem.attributeCode.toLowerCase()}`));
              const ageColorElement = ageRangesColors.find(color => color.slug === elem.attributeCode.toString())
              obj.patients.ageGraph.data.datasets[0].backgroundColor.push( ageColorElement ? ageColorElement.color : '#'+(Math.random()*0xFFFFFF<<0).toString(16))
              //obj.patients.ageGraph.data.datasets[0].backgroundColor.push('#'+(Math.random()*0xFFFFFF<<0).toString(16))
              obj.patients.ageGraph.data.datasets[0].data.push(parseInt(elem.cases));
              break;
            case "APPOINTMENTS_NUMBER":
              obj.evaluations.total = elem.value
              break;
            case "TESTS_NUMBER":
              obj.evaluations.totalTests = elem.value
              break;
            case "MEAN_TESTS_APPOINTMENT":
              obj.evaluations.meanTests = elem.value
              break;
            case "MEAN_DURATION_APPOINTMENT":
              obj.evaluations.meanDuration = elem.value
              break;
            case "BIOMEDICAL_TESTS_NUMBER":
            case "GERIATRIC_TESTS_NUMBER":
            case "HEARING_TESTS_NUMBER":
            case "VISION_TESTS_NUMBER":
            case "QUESTIONNAIRE_TESTS_NUMBER":
            case "COMPLEX_MONITORING_TESTS_NUMBER":
            case "BIOSIGN_TESTS_NUMBER":
            case "BIOCHEMICAL_TESTS_NUMBER":
              obj.evaluations.evaluationsGraph.data.labels.push(this.$t(`dashboard_new_evollu.kpis.labels.${elem.attributeCode.toLowerCase()}`));
              const colorElement = testsGraphColors.find(color => color.slug === elem.attributeCode)
              obj.evaluations.evaluationsGraph.data.datasets[0].backgroundColor.push( colorElement ? colorElement.color : '#'+(Math.random()*0xFFFFFF<<0).toString(16))
              obj.evaluations.evaluationsGraph.data.datasets[0].data.push(parseInt(elem.value));
              break;
          }
        })
      }

      this.parsedData = obj
    },
    onCancel() {
      this.facilityId = null;
    }
  },
  watch:{
    filters: {
      handler: function () {
        //LocalStorageHelper.set(KPIS_DASHBOARD_NEW_EVOLLU, this.filters)
        if(this.filters.facility !== null && this.filters.period){
          this.getKpisData()
        }

      },
      deep: true,
      immediate: true
    },
  },
}

</script>

<style scoped>
.card {
  border-radius: 15px !important;
  width: 100%;
  padding-top:0 !important;
  margin-top: 20px;
  margin-left: 20px;
  margin-right: 20px;
}

</style>
